// Add your custom JS here.
import Swiper from "swiper/bundle";
import { register } from "swiper/element/bundle";
register();

const swiper1 = new Swiper(".swiper", {
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const swiperEl = document.getElementById("news-carousel-wc");
if (swiperEl) {
  document
    .querySelector("#newsCarouselButtonPrev")
    .addEventListener("click", (e) => {
      swiperEl.swiper?.slidePrev();
    });
  document
    .querySelector("#newsCarouselButtonNext")
    .addEventListener("click", (e) => {
      swiperEl.swiper?.slideNext();
    });
}

const productSwiper = document.querySelector(".product-gallery-slider");
if (productSwiper) {
  document
    .querySelector("#productCarouselButtonPrev")
    .addEventListener("click", (e) => {
      productSwiper.swiper?.slidePrev();
    });
  document
    .querySelector("#productCarouselButtonNext")
    .addEventListener("click", (e) => {
      productSwiper.swiper?.slideNext();
    });
}

// Watch all acordion items and add hover event listeners
const accordionItems = document.querySelectorAll(
  ".services-container .accordion-item"
);
accordionItems.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    const id = item.getAttribute("data-id");
    const imageItem = document.querySelector(
      `.services-container .image-item[data-id="${id}"]`
    );
    if (imageItem) {
      imageItem.classList.add("active");
    }
  });
  item.addEventListener("mouseleave", () => {
    // Remove active class from all image items
    const activeImageItems = document.querySelectorAll(
      ".services-container .image-item.active"
    );
    activeImageItems.forEach((activeItem) => {
      activeItem.classList.remove("active");
    });
  });
});

// For all accordion items, set the image to be 'opened' when the accordion is open, remove 'opened' when closed
const accordionHeaders = document.querySelectorAll(
  ".services-container .accordion-header"
);
accordionHeaders.forEach((header) => {
  header.addEventListener("click", () => {
    const item = header.closest(".accordion-item");
    const id = item.getAttribute("data-id");
    const imageItem = document.querySelector(
      `.services-container .image-item[data-id="${id}"]`
    );

    // Toggle 'opened' class on the current image item
    if (imageItem) {
      imageItem.classList.toggle("opened");
    }

    // Remove 'opened' class from all image items
    const openedImageItems = document.querySelectorAll(
      ".services-container .image-item.opened"
    );
    openedImageItems.forEach((openedItem) => {
      // Besides toggling the current item, remove 'opened' from all others
      if (openedItem !== imageItem) {
        openedItem.classList.remove("opened");
      }
    });
  });
});

const searchForm = document.querySelector(".product-search form");
if (searchForm) {
  const radioButtons = searchForm.querySelectorAll('input[type="radio"]');
  radioButtons.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const target = e.target.value;
      if (target) {
        const basePath = window.location.pathname;
        searchForm.action = `${basePath}${
          basePath !== "/" ? "/" : ""
        }${target}`;
      }
    });
  });
}

function autoFitText(selector, options = {}) {
  const settings = {
    minFontSize: 8,
    maxFontSize: 100,
    step: 1,
    breakpoint: 768,
    ...options,
  };

  // Create media query
  const mediaQuery = window.matchMedia(
    `(min-width: ${settings.breakpoint + 1}px)`
  );

  function fitElement(element) {
    if (!element || !element.parentElement) return;

    // Check if we're above the breakpoint
    if (!mediaQuery.matches) {
      // Below breakpoint - reset and allow wrapping
      element.style.fontSize = "";
      element.style.whiteSpace = "normal";
      return;
    }

    // Above breakpoint - apply fitting
    element.style.whiteSpace = "nowrap";

    const containerWidth = element.parentElement.clientWidth;
    if (containerWidth <= 0) return;

    let fontSize = settings.maxFontSize;
    element.style.fontSize = fontSize + "px";

    while (
      element.scrollWidth > containerWidth &&
      fontSize > settings.minFontSize
    ) {
      fontSize -= settings.step;
      element.style.fontSize = fontSize + "px";
    }
  }

  const elements = document.querySelectorAll(selector);

  function handleResize() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        elements.forEach(fitElement);
      });
    });
  }

  // Initial fit
  elements.forEach(fitElement);

  // Listen to media query changes
  mediaQuery.addEventListener("change", handleResize);

  // Still listen to window resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 100);
  });
}

// Usage
autoFitText(".fit-text", {
  minFontSize: 10,
  maxFontSize: 90,
  breakpoint: 648,
});

// CF7 missing error messages fix. Ensuring that error responses render under floating label inputs
document.addEventListener('wpcf7invalid', function (e) {
    const form = e.target;
    form.querySelectorAll('.custom-error').forEach(el => el.remove());
    form.querySelectorAll('.wpcf7-not-valid').forEach(el => el.classList.remove('wpcf7-not-valid'));

    (e.detail.apiResponse.invalid_fields || []).forEach(function (item) {
        const field = form.querySelector('[name="' + item.field + '"]');
        if (!field) return;
        field.classList.add('wpcf7-not-valid');
        const tip = document.createElement('div');
        tip.className = 'custom-error text-danger small';
        tip.style.marginTop = "-1.25rem";
        tip.textContent = item.message;
        field.closest('.form-floating').insertAdjacentElement('afterend', tip);
    });
});
